/* RESPONSIBLE TEAM: team-standalone */
import { RenderableType } from 'embercom/models/data/inbox/renderable-types';
import { type RenderableData } from 'embercom/objects/inbox/renderable-data';
import { EntityType } from 'embercom/models/data/entity-types';

interface StandalonePlatformHandoffWireFormat {
  renderable_type: RenderableType;
  handoff_type: string;
  handoff_success: boolean;
}

export default class StandalonePlatformHandoff implements RenderableData {
  readonly renderableType: RenderableType = RenderableType.StandalonePlatformHandoff;
  readonly handoffType: string;
  readonly handoffSuccess: boolean;

  constructor(handoff_type: string, handoff_success: boolean) {
    this.handoffType = handoff_type;
    this.handoffSuccess = handoff_success;
  }

  get adminOnly() {
    return true;
  }

  get creatingEntity() {
    return { type: EntityType.Bot, id: -1 };
  }

  static deserialize(json: StandalonePlatformHandoffWireFormat): StandalonePlatformHandoff {
    return new StandalonePlatformHandoff(json.handoff_type, json.handoff_success);
  }
}
